/* Only opacity and header measurements need JS. All movement uses native scrolling. */
(() => {
  if (window.ICIKOLScrollStory) return;
  const stories = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let raf = 0;
  function update() {
    raf = 0;
    const header = document.querySelector('.shopify-section-group-header-group');
    const headerHeight = header ? header.getBoundingClientRect().height : 0;
    for (const [story, state] of stories) {
      if (!story.isConnected) { stories.delete(story); continue; }
      if (headerHeight) story.style.setProperty('--story-header', `${Math.round(headerHeight)}px`);
      if (!state.visible) continue;
      const passed = headerHeight - story.getBoundingClientRect().top;
      const opacity = reduced.matches ? 1 : Math.max(0, Math.min(1, passed / 170));
      story.style.setProperty('--story-logo-opacity', opacity.toFixed(3));
      story.classList.add('is-motion-ready');
    }
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(update); }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) { const state = stories.get(entry.target); if (state) state.visible = entry.isIntersecting; }
    schedule();
  }, { rootMargin: '200px' }) : null;
  function mount(root = document) {
    root.querySelectorAll('[data-scroll-story]').forEach(story => {
      if (stories.has(story)) return;
      stories.set(story, { visible: true });
      observer?.observe(story);
    });
    schedule();
  }
  function unmount(root) {
    for (const story of stories.keys()) if (root.contains(story)) { observer?.unobserve(story); stories.delete(story); }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  reduced.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  if ('ResizeObserver' in window) {
    const header = document.querySelector('.shopify-section-group-header-group');
    if (header) new ResizeObserver(schedule).observe(header);
  }
  window.ICIKOLScrollStory = { mount };
  mount();
})();
